export const spekWalk = {
    spekWalk: 'SpeK-Walk Summary Review',
    spekCall: 'SpeK-Call Summary Review',
    spekDate: 'Spek-Walk Date',
    review: 'Categories to be Reviewed:',
    category: 'Category',
    totalCost: 'Total cost',
    subCategory: 'Sub-Category',
    summary: 'Summary Review of Discussion',
    cost: 'Approximate Cost Estimate',
    itemNumber: 'Item Number',
    delete: 'Remove',
    drag: 'Drag me',
    pagination: 'Items per page',
    'addBtn': 'Blank Solution Estimate Template',
    'submit': 'Submit',
    addMultiple : 'Add 10 Solution Estimate Template',
    selectCategories: 'Selected categories',
    noCategory: 'No category selected',
    back: 'Back',
    clickHere: 'Click here to open site',
    action: 'Action',
    edit: 'Edit',
    remove: 'Remove',
    editCategory: 'Edit Category',
    beforeApprove: 'Approve to go to customer',
    afterApprove: 'Approved',
    alterSolution: 'Alter Solution',
    print: 'Print Document',
    saveDragSolution:'Save Drag Solution',
    categoriesList: [
        {
            key: 'Roofing',
            value: 'Roofing',
            checked: false
        },
        {
            key: 'Interiors',
            value: 'Interiors',
            checked: false
        },
        {
            key: 'Structural Component',
            value: 'Structural Component',
            checked: false
        },
        {
            key: 'Heating/Central Air Conditioning',
            value: 'Heating/Central Air Conditioning',
            checked: false
        },
        {
            key: 'Insulation and Ventilation',
            value: 'Insulation and Ventilation',
            checked: false
        },
        {
            key: 'Built-In Kitchen Appliances',
            value: 'Built-In Kitchen Appliances',
            checked: false
        },
        {
            key: 'Exterior',
            value: 'Exterior',
            checked: false
        },
        {
            key: 'Plumbing System',
            value: 'Plumbing System',
            checked: false
        },
        {
            key: 'Electrical System',
            value: 'Electrical System',
            checked: false
        },
        {
            key: 'Other',
            value: 'Other',
            checked: false
        }
    ],
    categoryDisplayValue: {
        'Roofing': 'Roofing',
        'Interiors': 'Interiors',
        'Structural Component': 'Structural Component',
        'Heating/Central Air Conditioning': 'Heating/Central Air Conditioning',
        'Insulation and Ventilation': 'Insulation and Ventilation',
        'Built-In Kitchen Appliances': 'Built-In Kitchen Appliances',
        'Exterior': 'Exterior',
        'Plumbing System': 'Plumbing System',
        'Electrical System': 'Electrical System',
        'Other': 'Other',
    }

}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/utils/e-commerce/spekWalk.ts